<template>
    <div  v-if="isEditing">
        <b-form-checkbox switch v-if="isType(['boolean'])" v-model="myValue"  @input="updateBooleanValue()" >
            <b>({{ myValue===undefined?'false':myValue }})</b>
        </b-form-checkbox>
        <input class="form-control form-control-sm" v-if="isType(['time'])" v-model="myValue" :type='this.metadata.form.type' @input="updateValue()">
        <input class="form-control form-control-sm" v-if="isType(['date'])" v-model="formattingDate" :type='this.metadata.form.type' @input="updateValue()">
        <mes-dim-search 
            v-if="isType(['dimSearch'])"  
            v-model="myValue"
            :config="config"
            :url='url'
            key='editDimSearch'
            @input="updateValue()"
        ></mes-dim-search>
        <b-form-select      v-if="isType(['select', 'entitySelect'])" v-model="myValue" :options="options" @input="updateValue()"/>
        <mmf-datepicker     v-if="isType(['datepicker'])"        ref="dp" name="date" :value="myValue" @input="updateValue($event)"></mmf-datepicker>
        <mes-time-picker    v-if="isType(['timepicker'])" :value='myValue' @input="updateValue($event)"></mes-time-picker>
        <mmf-datetimepicker v-if="isType(['datetimepicker'])"    ref="dtp" name="datetime" :value="myValue" @input="updateValue($event)"></mmf-datetimepicker>
        <b-form-textarea    v-if="isType(['textarea'])"          v-model="myValue" rows="1" max-rows="6" @input="updateValue()"/>
        <div v-if="isType(['input'])">
            <input type='text' v-model="myValue" class="form-control" @input="updateValue()"/>
        </div>
        <div v-if="isType(['input-number'])">
            <input type='number' v-model="myValue" class="form-control" @input="updateValue()"/>
        </div>
    </div>
    <div v-else-if="isType(['select', 'boolean'])">
        {{ getOption() }}
    </div>
    <div v-else-if="isType(['dimSearch'])" >
        <!-- 如果不加上 key ,当 isEditing 变更后，会认为和上面是同一个元素
        会导致无法显示出 输入框中的内容 -->
        <mes-dim-search
            v-model="myValue"
            :config="config"
            :url='url'
            displayAsConstant
            key='showDimSearch'
            @input="updateValue()"
        ></mes-dim-search>
    </div>
     <div v-else-if="isType(['color'])">
       <colorPicker disabled  v-model="myValue" />
    </div>
    <div v-else>
        {{ formatedValue }}<span v-if="showDayLightTimeIcon"><i class="fa fa-fw fa-lg fa-sun"></i></span>
    </div>
</template>

<script>
import MmfDatepicker from '@/components/MmfDatepicker';
import MmfDatetimepicker from '@/components/MmfDatetimepicker';
import MesTimePicker from '@/components/MesTimePicker'
import MesDimSearch from '@/components/MesDimSearch';
import moment from 'moment';
import  { TIMEZONE }  from '@/model/constants'
import {date2timeStr,date2str} from '@/utils/day'

const typeMapping = {
    'select': {
    },
    'boolean': {
        options: [
            { value: "", text: 'lbl.basic.select.one' },
            { value: true, text: 'lbl.basic.yes' },
            { value: false, text: 'lbl.basic.no' }
        ]
    },
    'datepicker': {
    },
    'datetimepicker': {
    },
    'textarea': {
    },
    'input': {
    },
    'input-number': {
    }
};

export default {
    name: "mmf-form-helper",
    components: { MmfDatepicker , MmfDatetimepicker , MesTimePicker, MesDimSearch},
    props: {
        'metadata': Object,
        'value': [ String, Number, Boolean, Array, Object, Date, Function, Symbol],
        'isEditing': {
            type: Boolean,
            default: false
        }
    },
    watch:{
        value(newValue){
            this.myValue = newValue;
        }
    },
    data: function() {
        return {
            myValue: this.value
        }
    },
    computed: {
        // myValue:{
        //     get(){
        //         return  this.value
        //     },
        //     set(){}
        // },
        options() {
            var optionsNotTranslated = null;
            var options = null;
            var form = this.metadata.form
            switch (form.type) {
                case 'select':
                    if (form.options != undefined){
                        optionsNotTranslated = form.options;
                    }
                    break;
                case 'boolean':
                    optionsNotTranslated = typeMapping['boolean'].options;
                    break;
                case 'entitySelect':
                    options = this.$store.state[form.entity].selectItems
                    if ((!form.hasOwnProperty('showLabelSelectOne') || form.showLabelSelectOne) && options.length > 0){
                        var selectOne = [{ value:"", text: this.$t("lbl.basic.select.one") }]
                        options = selectOne.concat(options)
                    }
                    break;
            }
            if (optionsNotTranslated) {
                let $this = this
                options = optionsNotTranslated.map(x => { return { value: x.value, text: $this.$t(x.text) } })
            }
            return options;
        },
        showDayLightTimeIcon(){
            if(this.metadata.form.type == 'datetimepicker'){
                return  (moment(this.value).isDST() && this.$store.getters['userPreferences/getTimezone'] == TIMEZONE.DST)
            } else{
                return false
            }  
        },
        formatedValue() {
            switch (this.metadata.form.type){
                case 'datetimepicker':
                    var retorno = this.value != null ? moment(this.value).format(this.$store.getters["userPreferences/getDateTimeString"]) : "";
                    return retorno;
                case 'date': // 和 datepicker 相同
                case 'datepicker':
                    return this.value != null ? moment(this.value).format(this.$t("date.format.viewMode")) : "";
                case 'displayTime':
                    return date2timeStr(new Date(this.value))  
                case 'timepicker':
                    return this.value != null ? date2timeStr(new Date(this.value)) : ""
                case 'dater':
                    return this.value != null ? date2str(new Date(this.value)) : ""  
                case 'dateTime':
                    return this.value != null ? date2timeStr(new Date(this.value)) : ""
                case 'month':
                    return this.value != null ? moment(this.value).format(this.$t("month.format.viewMode")) : "";
                default:
                    return this.value;
            }
        },
        url(){
            return this.metadata.form.url;
        },
        config(){
            return this.metadata.form.config;
        },
        formattingDate:{
            get(){
                return date2str(new Date(this.myValue))
            },
            set(val){
                this.myValue = val
            }
        }
    },
    mounted() {
        if (this.metadata.form.type === 'entitySelect' && !this.metadata.form.hasOwnProperty('dependsOn')) {
            this.$store.dispatch(this.metadata.form.entity + '/retrieveForSelect', { root: true })
        }
        this.$emit('bind', this.myValue);
    },
    methods: {
        isType(types) {
            return types.indexOf(this.metadata.form.type) >= 0
        },
        getOption() {
            let selectedOption = this.options.filter(x => x.value === this.value)
            if (selectedOption.length > 0) {
                return selectedOption[0].text;
            }
            return null;
        },
        updateValue(value = null) {
            if (value){
                this.$emit('input', value);
            }
            else {
                this.$emit('input', this.myValue);
            }
        },
        updateBooleanValue() {
            if (this.myValue != null){
                this.$emit('changeBooleanValue', this.myValue);
            }
        }
    }
}
</script>              